export function nameToUrlSegment(name?: string): string {
    if (!name) {
        return "";
    }

    return encodeURIComponent(
        name.toLowerCase().replace(/\s/g, "-").replace("&", "").replace(/\//, "-").replace(/-+/, "-")
    );
}

export function getCMSDocumentPath(
    type: "docs" | "blog" | "pages" | "authorized-channel-insights" | "snippets",
    language: string,
    routePath: string | string[] | undefined
) {
    const path = ["cms", language, type];

    if (Array.isArray(routePath)) {
        path.push(...routePath);
    } else if (typeof routePath === "string") {
        path.push(routePath);
    }

    return "/" + path.join("/");
}

export function isValidUrl(urlString: string) {
    // It would be better to use URL.canParse, but it only works on Chrome 120 and later.
    // The following is based on the canParse polyfill in core-js
    try {
        return !!new URL(urlString);
    } catch (_error) {
        return false;
    }
}
